/*global jQuery:false */
jQuery(document).ready(function () {
    'use strict';

    var plusBtn = '.product-card .btn--plus';
    var plusBtnDisabled = '.product-card .btn--minus';
    var minusBtn = '.product-card .btn--plus:disabled';
    var minusBtnDisabled = '.product-card .btn--minus:disabled';

    jQuery(plusBtn).bind('click', function (e) {
        $(plusBtn).attr('aria-describedby', 'added-live--plus');
        setTimeout(function () {
            $(plusBtn).removeAttr('aria-describedby');
            $(plusBtnDisabled).removeAttr('aria-describedby');
        }, 300);

        e.preventDefault();
    });

    jQuery(plusBtnDisabled).bind('click', function (e) {
        $(plusBtnDisabled).attr('aria-describedby', 'added-live--plus--disabled');
        setTimeout(function () {
            $(plusBtnDisabled).removeAttr('aria-describedby');
            $(plusBtn).removeAttr('aria-describedby');
        }, 300);

        e.preventDefault();
    });


    jQuery(minusBtn).bind('click', function (e) {
        $(minusBtn).attr('aria-describedby', 'added-live--minus');
        setTimeout(function () {
            $(minusBtn).removeAttr('aria-describedby');
            $(minusBtnDisabled).removeAttr('aria-describedby');
        }, 300);

        e.preventDefault();
    });

    jQuery(minusBtnDisabled).bind('click', function (e) {
        $(minusBtnDisabled).attr('aria-describedby', 'added-live--plus--disabled');
        setTimeout(function () {
            $(minusBtnDisabled).removeAttr('aria-describedby');
            $(minusBtn).removeAttr('aria-describedby');
        }, 300);

        e.preventDefault();
    });

});
